/* ================================================================
   dd-pro-benefits.js — horizontal carousel controller

   Progressive enhancement over a native scroll-snap track:
     - prev/next arrows scroll by ~one viewport of cards
     - arrows disable at the start / end of the track
     - native swipe + trackpad scroll keep working with zero JS

   Singleton-guarded; supports multiple carousels on one page.
   ================================================================ */
(function () {
  'use strict';

  if (window._ddProBenefitsCarouselInit) return;
  window._ddProBenefitsCarouselInit = true;

  function initCarousel(root) {
    var track = root.querySelector('[data-dd-carousel-track]');
    var prev = root.querySelector('[data-dd-carousel-prev]');
    var next = root.querySelector('[data-dd-carousel-next]');
    if (!track || !prev || !next) return;

    // Tolerance so sub-pixel scroll widths don't leave an arrow stuck enabled.
    var EDGE = 2;

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function updateArrows() {
      var max = maxScroll();
      // If everything fits, hide the whole nav.
      if (max <= EDGE) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      var x = track.scrollLeft;
      prev.disabled = x <= EDGE;
      next.disabled = x >= max - EDGE;
    }

    function page() {
      // Scroll by ~90% of the visible track so a card edge stays in view.
      return Math.max(track.clientWidth * 0.9, 200);
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -page(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: page(), behavior: 'smooth' });
    });

    // Throttle scroll updates with rAF so we touch the DOM once per frame.
    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateArrows();
          ticking = false;
        });
      },
      { passive: true }
    );

    // Recompute on resize (card widths change at breakpoints).
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateArrows, 150);
    });

    // Re-measure once fonts/images settle (track width can shift).
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateArrows).catch(function () {});
    }
    setTimeout(updateArrows, 300);

    updateArrows();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-dd-carousel]');
    for (var i = 0; i < roots.length; i++) {
      try {
        initCarousel(roots[i]);
      } catch (err) {
        console.error('[dd-pro-benefits] carousel init failed', err);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
